import templateUrl from 'emun.salesrep/salesrep-goals-prompt.htm'
import SalesRepGoalsPromptController from 'emun.salesrep/salesrep-goals-prompt.controller'
import open from "webmodals/open";
import modals from 'webmodals/modals'

const SalesRepGoalsPrompt = {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            // placement: 'right',
            //backdrop: false,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: SalesRepGoalsPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};
/*
let SalesRepGoalsPrompt = (options) => {
	let modalInstance = open({
		size: options.size || 'md',
		templateUrl: options.templateUrl || templateUrl,
		controller: SalesRepGoalsPromptController,
		bindToController: true,
		controllerAs: '$ctrl',
		resolve: {
			options: () => options
		}
	});

	return modalInstance.result;
}
*/
export default SalesRepGoalsPrompt;